// extracted by mini-css-extract-plugin
module.exports = {"heart":"_c19ac237","folder":"_e2420deb","folderIcon":"_75776c40","isAnimated":"_f46d4258","isFilled":"_c0c65c29"};